import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import i18n from '../../utils/i18n';
import ReactAsyncSelect from 'react-select/async';

/**
 * @typedef AsyncSelectCustomProps
 * @prop {any} className
 *
 * @typedef { import('react-select/dist/declarations/src/Select').Props &
 * import('react-select/dist/declarations/src/useAsync').AsyncAdditionalProps &
 * AsyncSelectCustomProps
 * } AsyncSelectProps
 */

/**
 *
 * @param { AsyncSelectProps } props
 * @returns
 */
const AsyncSelect = ({
  className,
  error,
  defaultValue,
  value,
  disabled,
  options,
  noOptionsMessage,
  onChange,
  name,
  id,
  ...props
}) => {
  const [internalVal, setInternalVal] = useState();

  useEffect(() => {
    if (defaultValue && typeof defaultValue === 'string' || typeof defaultValue === 'number') {
      const newValue = options.find(opt => opt.value === value);
      if (newValue) {
        setInternalVal(newValue);
      }
    }
  }, []);

  useEffect(() => {
    if (internalVal && internalVal.value === value) return;
    if ((typeof value === 'string' || typeof value === 'number') && Array.isArray(options)) {
      const newValue = options.find(opt => opt.value === value);
      if (newValue) {
        setInternalVal(newValue);
      }
    }
  }, [value, internalVal]);

  const handleOnChange = (val, meta) => {
    setInternalVal(val);
    let value;

    if (Array.isArray(val)) {
      value = val.map(option => option.value);
    } else {
      value = val ? val.value : null;
    }

    if (onChange) {
      if (name || id) {
        onChange({
          target: {
            name: name || id,
            value
          }
        });
      } else {
        onChange(val, meta);
      }
    }
  };

  return (<ReactAsyncSelect
    className={classNames('obviously-select-container', className, { error })}
    classNamePrefix='obviously-select'
    defaultValue={defaultValue}
    value={internalVal}
    isDisabled={disabled}
    onChange={handleOnChange}
    id={id}
    options={options}
    noOptionsMessage={noOptionsMessage}
    {...props}>
  </ReactAsyncSelect>);
};

AsyncSelect.propTypes = {
  className: PropTypes.string,
  error: PropTypes.bool,
  defaultValue: PropTypes.any,
  placeholder: PropTypes.any,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
      ]).isRequired,
    })),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  name: PropTypes.string,
  id: PropTypes.string,
  isMulti: PropTypes.bool,
  noOptionsMessage: PropTypes.func,
  disabled: PropTypes.bool,
  value: PropTypes.any,
};

AsyncSelect.defaultValue = {
  className: '',
  error: false,
  defaultValue: null,
  placeholder: null,
  options: [],
  onChange: null,
  onBlur: null,
  name: null,
  id: null,
  isMulti: false,
  noOptionsMessage: () => i18n.t('influencers.common.no_options'),
  disabled: false,
  value: null
};

export default AsyncSelect;